// RU-MCXCHAINQ MQ-7: how fresh an option chain's quotes are. The backend sends quote_ts / age_s / stale /
// stale_after_s on MCX chains (chain and every row); a chain without them (index, stock, generated) shows nothing.

const num = (v) => (typeof v === "number" && Number.isFinite(v) ? v : null);

export function formatAge(sec) {
  const s = num(sec);
  if (s == null || s < 0) return "—";
  const whole = Math.round(s);
  if (whole < 60) return `${whole} s`;
  const m = Math.floor(whole / 60);
  const r = whole % 60;
  return r ? `${m} min ${r} s` : `${m} min`;
}

function quoteClock(ts) {
  if (!ts) return null;
  const m = /T(\d{2}:\d{2}:\d{2})/.exec(String(ts));
  return m ? m[1] : String(ts);
}

// null when the chain carries no freshness; otherwise what the page shows above the table.
export function chainFreshness(chain) {
  if (!chain || num(chain.age_s) == null) return null;
  const staleAfter = num(chain.stale_after_s);
  const stale = chain.stale === true || (staleAfter != null && chain.age_s > staleAfter);
  return {
    stale,
    cached: chain.source === "stale_cache",
    age: formatAge(chain.age_s),
    quoteTime: quoteClock(chain.quote_ts || chain.as_of),
    staleAfter: staleAfter != null ? formatAge(staleAfter) : null,
  };
}

// A row is stale when it says so, or when its chain is stale (never hidden: either one marks the row).
export function rowIsStale(row, chain) {
  if (!row) return false;
  if (row.stale === true || (chain && chain.stale === true)) return true;
  const after = num(chain && chain.stale_after_s);
  return after != null && num(row.age_s) != null && row.age_s > after;
}
